export default "__VITE_ASSET__MHq41EVn__"